import React from 'react';

import BooksOfAccountsModule from './books-of-accounts.module';
import BooksOfAccounts from 'enums/books-of-accounts';

const BooksOfAccountsGeneralJournalModule = () => {
  return (
    <div>
      <BooksOfAccountsModule type={BooksOfAccounts.GeneralJournal} />
    </div>
  );
};

export default BooksOfAccountsGeneralJournalModule;
